import { render } from "./GraficaProveedoresMx.vue?vue&type=template&id=43d06bf9"
import script from "./GraficaProveedoresMx.vue?vue&type=script&lang=js"
export * from "./GraficaProveedoresMx.vue?vue&type=script&lang=js"

import "./GraficaProveedoresMx.vue?vue&type=style&index=0&id=43d06bf9&lang=css"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__